import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Auth } from "@aws-amplify/auth";
import { Authenticator, useTheme, View, Image, Button, Flex, Divider, Text, } from "@aws-amplify/ui-react";
import arupLogo from "../assets/arup_red.svg";
import "./Theme";
const AuthenticationProvider = (props) => {
    const config = {
        region: props.region,
        userPoolId: props.userPoolId,
        userPoolWebClientId: props.userPoolWebClientId,
        mandatorySignIn: true,
        oauth: {
            domain: props.domain,
            scope: props.scope || ["email", "profile", "openid"],
            redirectSignIn: window.location.origin,
            redirectSignOut: window.location.origin,
            responseType: "code",
        },
    };
    Auth.configure(config);
    const renderApp = () => _jsx(_Fragment, { children: props.children });
    const HideForm = React.lazy(() => import("./HideForm"));
    const components = {
        Header() {
            const { tokens } = useTheme();
            return (_jsxs(View, Object.assign({ textAlign: "center", padding: tokens.space.large }, { children: [_jsx(React.Suspense, Object.assign({ fallback: _jsx(_Fragment, {}) }, { children: props.hideFormFields && _jsx(HideForm, {}) })), _jsx(Image, { alt: "Arup logo", src: arupLogo, maxWidth: "50%" })] })));
        },
        SignIn: {
            Header() {
                return (_jsx(_Fragment, { children: props.azureADProviderId && (_jsx(_Fragment, { children: _jsxs(Flex, Object.assign({ padding: "var(--amplify-space-xl) var(--amplify-space-xl) 0 var(--amplify-space-xl)", direction: "column" }, { children: [_jsx(Button, Object.assign({ width: "100%", fontWeight: "500", color: "var(--amplify-colors-brand-primary-50)", border: "1px solid var(--amplify-colors-brand-primary-50)", onClick: () => {
                                        Auth.federatedSignIn({
                                            provider: props.azureADProviderId,
                                        });
                                    } }, { children: props.hideFormFields
                                        ? "Sign in"
                                        : "Sign in with your Arup Account" })), _jsxs(Flex, Object.assign({ style: props.hideFormFields ? { visibility: "hidden" } : {} }, { children: [_jsx(Divider, { orientation: "horizontal", size: "small", alignSelf: "center" }), _jsx(Text, { children: "or" }), _jsx(Divider, { orientation: "horizontal", size: "small", alignSelf: "center" })] }))] })) })) }));
            },
        },
    };
    return (_jsx(Authenticator, Object.assign({ variation: "modal", components: components, hideSignUp: !props.allowSignUp }, { children: renderApp })));
};
export default AuthenticationProvider;
